import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "@core/services/auth";
import { map } from "rxjs/operators";


export const authGuard: CanActivateFn = () =>{
    const auth = inject(AuthService);
    const router = inject(Router);
    return auth.checkAuthStatus().pipe(
        map(isAuthenticated => isAuthenticated ? true : router.createUrlTree(['/login']))
    );
}